import { render, staticRenderFns } from "./c-list.vue?vue&type=template&id=496a80ae&scoped=true&"
import script from "./c-list.vue?vue&type=script&lang=js&"
export * from "./c-list.vue?vue&type=script&lang=js&"
import style0 from "./c-list.vue?vue&type=style&index=0&id=496a80ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496a80ae",
  null
  
)

export default component.exports